import {
	ConfluencePageAri,
	JiraIssueAri,
	TownsquareGoalAri,
	TownsquareProjectAri,
	IdentityTeamAri,
} from '@atlassian/ari';
import type { GlobalObjectType } from '@atlassian/preview-panel-global-objects';

import { fg } from '@confluence/feature-gating';

import { hasPreviewPanelIndicators, isInIframe } from './utils/previewPanelUtils.ts';

export const ALL_SUPPORTED_OBJECTS: GlobalObjectType[] = [
	'jira-issue',
	'confluence-page',
	'identity-team',
	'townsquare-goal',
	'townsquare-project',
];

export const isPreviewPanelAvailable = ({ ari }: { ari: string }) => {
	const href = window?.location?.href;

	if (href) {
		const searchParams = new URL(href).searchParams;

		if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') {
			return false;
		}
		if (isInIframe() && !hasPreviewPanelIndicators(searchParams)) {
			return false;
		}
	}

	if (ConfluencePageAri.check(ari) && fg('confluence_preview_panels_confluence_integration')) {
		return true;
	}
	if (JiraIssueAri.check(ari) && fg('confluence_preview_panels_jira_integration')) {
		return true;
	}
	if (TownsquareGoalAri.check(ari) && fg('confluence_preview_panels_goals_integration')) {
		return true;
	}
	if (TownsquareProjectAri.check(ari) && fg('confluence_preview_panels_projects_integration')) {
		return true;
	}
	if (IdentityTeamAri.check(ari)) {
		return true;
	}

	return false;
};
